import get from './get'

export default (array = [], groupBy) =>
  array.reduce((r, v, i, a, k = get(v, groupBy)) => {
    (r[k] || (r[k] = [])).push(v)
    return r
  }, {})
